import { render, staticRenderFns } from "./newWork.vue?vue&type=template&id=5b07f962&scoped=true&"
import script from "./newWork.vue?vue&type=script&lang=js&"
export * from "./newWork.vue?vue&type=script&lang=js&"
import style0 from "./newWork.vue?vue&type=style&index=0&id=5b07f962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07f962",
  null
  
)

export default component.exports